<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
// import xy_config from './config/xy_config'
// import { loadEShopAPi } from './https/loadData'
// import eshopAPI from './api/eshopAPI'
export default {
  name: 'App',
  created () {
    // 自动登录开发阶段使用,后期上线需要注释掉
    this.initData()
  },
  methods: {
    async initData () {
      // const res = await loadEShopAPi(eshopAPI.login, { 'data[uid]': 'njkerun', 'data[pwd]': '123456' })
      // if (res && String(res.code) === '0' && res.data) {
      //   const date = new Date()
      //   date.setTime(res.data.expire_time)
      //   this.$cookie.set(xy_config.cookieToken, JSON.stringify(res.data), { expires: date, path: '/' })
      this.$store.dispatch('getMainData')
      this.$store.dispatch('getHomeConfigByType')
      this.$store.dispatch('getUserInfo')
      this.$store.dispatch('getSignInfo')
      // }
    }
  }
}
</script>

<style lang="less">
#app {
  height: 100%;
}
</style>
